import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../shared/services/order.service';
import { Order } from '../../shared/models/order';

@Component({
  selector: 'dac-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.css']
})
export class OrderHistoryComponent implements OnInit {

  private _orders:Order[];
  private _isLoaded:boolean;

  constructor(
    private orderService:OrderService
  ) { 
    this._orders = [];
    this._isLoaded = false;
  }

  ngOnInit() {
    this.orderService.getOrderHistory().then(orders => {
      this._orders = orders;
      this._isLoaded = true;
    })
    .catch(error => {
      console.error(error);
    })
  }

  hasMoreResults() {
    return this.orderService.hasMoreResults();
  }

  loadMore() {
    this.orderService.loadMore().then(orders => this._orders = orders);
  }

  get isLoaded() {
    return this._isLoaded;
  }

  get hasOrders() {
    return this._orders && this._orders.length;
  }

  get orders() {
    return this._orders;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/order-history/order-history.component.ts